import { Env } from "../env.type";

const clientId = "24d0eeb2-ff08-4275-b6fb-f38d0d9da572";

const env: Env = {
  host: "https://gab.yduqs.com.br",
  nameAplication: "Gestão Automática de Bolsas - GAB",
  initialsApplication: "GAB",
  env: "prd",
  brand: "yduqs",
  api: "https://api.gab.yduqs.com.br",
  apm: "",
  auth: {
    clientId: clientId,
    authority: `https://login.microsoftonline.com/29e081cc-983f-4d52-b1d0-103595213bc6/`,
    //scopes: ['openid', 'offline_access', 'profile', 'User.Read'],
    scopes: [`${clientId}/.default`],
  },
};

export default env;
